import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import Customer from './Components/CustomerDetails/Customer';
import CustomerImport from './Components/CustomerDetails/CustomerImport';
import Export from './Components/Invoice/export';
import Invoice from './Components/Invoice/Invoice';
import NewInvoice from './Components/Invoice/NewInvoice';
import InvoiceImport from './Components/Invoice/InvoiceImport';
import InvoicePdf from './Components/Invoice/InvoicePdf';
import ExportCustomer from './Components/CustomerDetails/exportcustomer';
import AddCustomer2 from './Components/CustomerDetails/AddCustomer2';
import AddCustomer3 from './Components/CustomerDetails/AddCustomer3';
import Expenses from './Components/Expense/Expense';

import TeamDepartment from './Components/TeamDepartment';
import TeamDirectory from './Components/TeamDirectory';
import TeamAttendance from './Components/TeamAttendance';
import Plan from './Components/Plan';
import Branch from './Components/Branch';
import Updates from './Components/Updates';
import Equipments from './Components/Equipments';
import Renewals from './Components/Renewals';
import Category from './Components/Category';
import Pincode from './Components/Pincode';
import Delivery from './Components/Delivery';
import Coupon from './Components/Coupon';
import Orders from './Components/Orders';
import Location from './Components/Location';
import AddTimeLog from './Components/AddTimeLog';
import TimeLog from './Components/TimeLog';
import SalaryDetail from './Components/SalaryDetail';
import Gallery from './Components/Gallery';
import Login from './Components/Login';
import UserRecordSuper from './Components/UserRecordSuper';
import { ToastContainer } from 'react-toastify';
import LeadsUpdated from './Components/Leads/LeadsUpdated';
import AddCategory from './Components/AddCategory';
import ListHomeCategory from './Components/ListHomeCategory';
import AddFeatureCategory from './Components/CategoryFeatured/AddFeaturedCategory';
import ListFeaturedHomeCategory from './Components/CategoryFeatured/ListFeaturedHomeCategory';
import AddDeveloperCategory from './Components/CategoryDeveloper/AddDeveloperCategory';
import ListDeveloperHomeCategory from './Components/CategoryDeveloper/ListDeveloperHomeCategory';
import Slider from './Components/Slider';
import PropertyCategory from './Components/PropertyCategory';
import PropertyForm from './Components/PropertyForm';
import MyProperty from './Components/MyProperty';
import Amenities from './Components/Amenities';
import LocationAdvantage from './Components/LocationAdvantage';
import ProtectedRoute from './Components/ProtectedRoute';
import NotFound from './Components/NotFound';
import Slider2 from './Components/Slider2'
import PropertyCategoryUpdate from './Components/PropertyCategoryUpdated';
import MyProjectUpdated from './Components/MyProjectUpdated';
import AmenitiesUpdatedTable from './Components/AmenitiesUpdatedTable';
import LocationAdvantageUpdated from './Components/LocationAdvantageUpdated';
import LeadsUpdatedVersion from './Components/LeadsUpdatedVersion/LeadsUpdatedVersion';
import LoanEMICalculator from './Components/LoanEMICalulator';
import WaterSupply from './Components/WaterSupply';
import Security from './Components/Security';
import ResidentPropertyForm from './Components/ResidentPropertyForm';
import RentPropertyForm from './Components/RentPropertyForm';
import CommercialPropertyForm from './Components/CommercialPropertyForm';
import ResidentPropertyEdit from './Components/ResidentPropertyEdit';
import ResidentRentEdit from './Components/RentResidential';
import CommercialEdit from './Components/CommercialEdit';
import Feedback from './Components/Feedback';
import Schedule from './Components/Schedule';
import Marquee from './Components/Marquee/Marquee';
import ResetPassword from './Components/ResetPassword';
import Department from './Components/Department/Department';
import Setting from './Components/Setting/Setting';
import Offerings from './Components/Offering';
import ClearRedirect from './Components/ClearRedirect';

const App = () => {
    const location = useLocation();
    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
    const userLoggedIn = login && login.user_id;
    const hideSidebarRoutes = ['/login', '/register'];
    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || !userLoggedIn;
    return (
        <SidebarProvider>
            <div className="app-container">
                {/* Sidebar is always rendered */}
                {!shouldHideSidebar && <Sidebar />}
                {/* Main content area */}
                <div className={`main-content ${shouldHideSidebar ? 'full-width' : ''}`}>
                    <Routes>
                        {/* <Route path="/" element={<Dashboard />} />
                        <Route path="/customer" element={<Customer />} /> */}
                        {/* <Route path="/customer-import" element={<CustomerImport />} />
                        <Route path="/add-customer" element={<AddCustomer />} /> */}
                        {/* <Route path="/export" element={<Export />} />
                        <Route path="/invoice" element={<Invoice />} />
                        <Route path="/new-invoice" element={<NewInvoice />} />
                        <Route path="/invoice-import" element={<InvoiceImport />} />
                        <Route path="/activity-log" element={<ActivityLog />} />
                        <Route path="/time-log" element={<TimeLog />} />
                        <Route path="/performance" element={<EmployeePerformance />} />
                        <Route path="/salary" element={<Salaries />} /> */}
                        <Route path="/lead-old" element={<ProtectedRoute><LeadsUpdated /></ProtectedRoute>} />
                        <Route path="/" element={<ProtectedRoute><LeadsUpdatedVersion /></ProtectedRoute>} />
                        <Route path="/offerings" element={<ProtectedRoute><Offerings /></ProtectedRoute>} />
                        <Route path="/general-setting" element={<ProtectedRoute><Setting /></ProtectedRoute>} />
                        {/* <Route path="/received-payment" element={<ReceivedPayment />} />
                        <Route path="/due-payment" element={<DuePayment />} />
                        <Route path="/offerings" element={<Offerings />} />
                        <Route path="/onboarding" element={<Onboarding />} />
                        <Route path="/all-users" element={<AllUsers />} />
                        <Route path="/user-records" element={<UserRecords />} />
                        <Route path="/alluser-records" element={<UserRecordSuper />} />
                        <Route path="/age-group" element={<ClassAgeGroup />} />
                        <Route path="/class-level" element={<ClassLevels />} />
                        <Route path="/class-schedule" element={<ClassSchedule />} />
                        <Route path="/team-department" element={<TeamDepartment />} />
                        <Route path="/team-directory" element={<TeamDirectory />} />
                        <Route path="/team-attendance" element={<TeamAttendance />} />
                        <Route path="/plan" element={<Plan />} />
                        <Route path="/branch" element={<Branch />} />
                        <Route path="/updates" element={<Updates />} /> */}
                        {/* <Route path="/equipments" element={<Equipments />} />
                        <Route path="/expense" element={<Expenses />} />
                        <Route path="/renewals" element={<Renewals />} />
                        <Route path="/category" element={<Category />} />
                        <Route path="/pincode" element={<Pincode />} />
                        <Route path="/delivery" element={<Delivery />} />
                        <Route path="/coupon" element={<Coupon />} />
                        <Route path="/orders" element={<Orders />} /> */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/clear" element={<ClearRedirect />} />
                        {/* <Route path="/register" element={<Register />} /> */}
                        {/* <Route path="/add-customer-2" element={<AddCustomer2 />} />
                        <Route path="/location" element={<Location />} />
                        <Route path="/salary-detail" element={<SalaryDetail />} />
                        <Route path="/gallery" element={<Gallery />} /> */}
                        <Route path="/addcategory" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
                        <Route path="/addpropertycategory/:id" element={<ProtectedRoute><ListHomeCategory /></ProtectedRoute>} />
                        <Route path="/addfeaturedcategory" element={<ProtectedRoute><AddFeatureCategory /></ProtectedRoute>} />
                        <Route path="/addpropertyfeaturecategory/:id" element={<ProtectedRoute><ListFeaturedHomeCategory /></ProtectedRoute>} />
                        <Route path="/adddeveloper" element={<ProtectedRoute><AddDeveloperCategory /></ProtectedRoute>} />
                        <Route path="/adddeveloper/:id" element={<ProtectedRoute><ListDeveloperHomeCategory /></ProtectedRoute>} />
                        <Route path="/slider" element={<ProtectedRoute><Slider /></ProtectedRoute>} />
                        <Route path="/slider-2" element={<ProtectedRoute><Slider2 /></ProtectedRoute>} />
                        <Route path="/propertyCategory" element={<ProtectedRoute><PropertyCategory /></ProtectedRoute>} />
                        <Route path="/propertyCategory-2" element={<ProtectedRoute><PropertyCategoryUpdate /></ProtectedRoute>} />
                        <Route path="/addproperty" element={<ProtectedRoute><PropertyForm /></ProtectedRoute>} />
                        <Route path="/resident-property/:id" element={<ProtectedRoute><ResidentPropertyEdit /></ProtectedRoute>} />
                        <Route path="/rent-addproperty/:id" element={<ProtectedRoute><ResidentRentEdit /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty/:id" element={<ProtectedRoute><CommercialEdit /></ProtectedRoute>} />
                        <Route path="/feedback" element={<ProtectedRoute><Feedback /></ProtectedRoute>} />
                        <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
                        <Route path="/resident-addproperty" element={<ProtectedRoute><ResidentPropertyForm /></ProtectedRoute>} />
                        <Route path="/rent-addproperty" element={<ProtectedRoute><RentPropertyForm /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty" element={<ProtectedRoute><CommercialPropertyForm /></ProtectedRoute>} />
                        <Route path="/property" element={<ProtectedRoute><MyProperty /></ProtectedRoute>} />
                        <Route path="/property-2" element={<ProtectedRoute><MyProjectUpdated /></ProtectedRoute>} />
                        <Route path="/amenities" element={<ProtectedRoute><Amenities /></ProtectedRoute>} />
                        <Route path="/amenities-2" element={<ProtectedRoute><AmenitiesUpdatedTable /></ProtectedRoute>} />
                        <Route path="/location-advantage" element={<ProtectedRoute><LocationAdvantage /></ProtectedRoute>} />
                        <Route path="/location-advantage-2" element={<ProtectedRoute><LocationAdvantageUpdated /></ProtectedRoute>} />
                        <Route path="/water-supply" element={<ProtectedRoute><WaterSupply /></ProtectedRoute>} />
                        <Route path="/marquee" element={<ProtectedRoute><Marquee /></ProtectedRoute>} />
                        <Route path="/security" element={<ProtectedRoute><Security /></ProtectedRoute>} />
                        <Route path="/loan-emi-calculator" element={<ProtectedRoute><LoanEMICalculator /></ProtectedRoute>} />
                        <Route path="/department" element={<ProtectedRoute><Department /></ProtectedRoute>} />
                        <Route path="/team-department" element={<TeamDepartment />} />
                        <Route path="/team-directory" element={<TeamDirectory />} />
                        <Route path="/team-attendance" element={<TeamAttendance />} />
                        <Route path="/reset" element={<ResetPassword />} />
                        <Route path="/customer" element={<ProtectedRoute><Customer /></ProtectedRoute>} />
                        <Route path="/customer-import" element={<ProtectedRoute><CustomerImport /></ProtectedRoute>} />
                        <Route path="/export" element={<ProtectedRoute><Export /></ProtectedRoute>} />
                        <Route path="/invoice" element={<ProtectedRoute><Invoice /></ProtectedRoute>} />
                        <Route path="/new-invoice" element={<ProtectedRoute><NewInvoice /></ProtectedRoute>} />
                        <Route path="/invoice-import" element={<ProtectedRoute><InvoiceImport /> </ProtectedRoute>} />
                        <Route path="/invoice-pdf/:order_number" element={<ProtectedRoute> <InvoicePdf /></ProtectedRoute>} />
                        <Route path="/edit-invoice/:id" element={<ProtectedRoute><NewInvoice isEditMode={true} /></ProtectedRoute>} />
                        <Route path="/export-customer" element={<ProtectedRoute><ExportCustomer /></ProtectedRoute>} />
                        <Route path="/add-customer" element={<ProtectedRoute><AddCustomer2 /></ProtectedRoute>} />
                        <Route path="/edit-customer" element={<ProtectedRoute><AddCustomer3 /></ProtectedRoute>} />
                        <Route path="/expense" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
                        {/* Add more routes as needed */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>

            </div>
            <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 999999 }} />
        </SidebarProvider>
    );
};

export default App;
